// extracted by mini-css-extract-plugin
export default {"address-picker__edit-button":"address-picker__edit-button_xVXh1m1k","with-dropdown":"with-dropdown_DeSn9Yva"};